module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-ExtraBold.301e6452.otf";